const HYDROCARBONS_C49 = [
  "C1", "C2", "C3", "i-C4", "n-C4", "i-C5", "n-C5", "C6", "C7", "C8", "C9", "C10", "C11", "C12", "C13",
  "C14", "C15", "C16", "C17", "C18", "C19", "C20", "C21", "C22", "C23", "C24", "C25", "C26", "C27", "C28",
  "C29", "C30", "C31", "C32", "C33", "C34", "C35", "C36", "C37", "C38", "C39", "C40", "C41", "C42", "C43",
  "C44", "C45", "C46", "C47", "C48", "C49",
];
const HYDROCARBONS_C35 = HYDROCARBONS_C49.slice(0, HYDROCARBONS_C49.indexOf("C35") + 1);
const NON_HYDROCARBONS = ["N2", "CO2", "H2S"];

export const TEST_FEATURES = {
  "CCE Test Analysis": [
    "Saturation Pressure (psia)", "CCE Test Temperature (F)", "Oil Compressibility (10-6 x psi-1)",
    "CCE Oil Density (g/cc)", "CCE gas Z Factor",
  ],
  "DL Test Analysis": [
    "dl Test Temperature (F)", "dl Oil Density (g/cc)", "dl Bo (bbl/stb)", "dl Rs (scf/stb)",
    "dl Total Bo (bbl/stb)", "dl STO Density (g/cc)", "API Gravity - DL Test",
  ],
  "Viscosity Test Analysis": [
    "viscosity Test Temperature (F)", "Oil Viscosity (cP)", "Viscosity Ratio", "Gas Viscosity (cP)",
  ],
  "CVD Test Analysis": [
    "cvd Test Temperature (F)", "cvd Gas Z Factor", "cvd Gas Density (g/cc)", "cvd Oil Density (g/cc)",
    "cvd GOR (scf/stb)", "cvd Bo (bbl/stb)", "cvd STO Density (g/cc)",
  ],
};

export const ALL_TEST_FEATURES = [
  ...TEST_FEATURES["CCE Test Analysis"],
  ...TEST_FEATURES["DL Test Analysis"],
  ...TEST_FEATURES["Viscosity Test Analysis"],
  ...TEST_FEATURES["CVD Test Analysis"],
  "Reservoir Temperature (F)",
];

const RESERVOIR_PLUS = [
  "C7+", "C12+", "C20+", "C36+", "C50+",
  "C7+ MW (g/mol)", "C12+ MW (g/mol)", "C20+ MW (g/mol)", "C36+ MW (g/mol)", "C50+ MW (g/mol)",
  "C7+ Density (g/cc)", "C12+ Density (g/cc)", "C20+ Density (g/cc)", "C36+ Density (g/cc)", "C50+ Density (g/cc)",
];
const RESERVOIR_BULK = [
  "Oil Molar Mass (g/mol)", "GOR (scf/stb)", "STO Density (g/cc)", "API deg", "STO MW (g/mol)", "Flash Oil FVF (bbl/stb)",
];
const GAS_BULK_TAIL = [
  "Gas Gravity", "Gas MW (g/mol)", "Gas Z Factor", "Gross Energy Volume Content (BTU/scf)",
  "Dry Gross Energy Volume Content (BTU/scf)", "Net Energy Volume Content (BTU/scf)",
];

function buildCategories(dataType) {
  const liquidFraction = dataType === "mole" ? "Liquid Phase Molar Fraction" : "Liquid Phase Mass Fraction";
  const vaporFraction = dataType === "mole" ? "Vapor Phase Molar Fraction" : "Vapor Phase Mass Fraction";
  return {
    "Reservoir Fluid": {
      "Non-hydrocarbon": NON_HYDROCARBONS,
      Hydrocarbon: HYDROCARBONS_C49,
      "Plus Fraction Properties": RESERVOIR_PLUS,
      "Composition Bulk Properties": RESERVOIR_BULK,
      ...TEST_FEATURES,
    },
    "Flashed Oil": {
      "Non-hydrocarbon": NON_HYDROCARBONS,
      Hydrocarbon: HYDROCARBONS_C49,
      "Plus Fraction Properties": ["C7+", "C12+", "C20+", "C36+", "C50+"],
      "Composition Bulk Properties": [liquidFraction, "STO Density (g/cc)", "API deg", "STO MW (g/mol)"],
    },
    "Flashed Gas": {
      "Non-hydrocarbon": NON_HYDROCARBONS,
      Hydrocarbon: HYDROCARBONS_C35,
      "Plus Fraction Properties": ["C7+", "C12+", "C20+", "C36+"],
      "Composition Bulk Properties": [vaporFraction, ...GAS_BULK_TAIL],
    },
  };
}

export const CATEGORIES_MOLE = buildCategories("mole");
export const CATEGORIES_WT = buildCategories("wt");

export function categoriesFor(dataType) {
  return dataType === "mole" ? CATEGORIES_MOLE : CATEGORIES_WT;
}

export const COMPOSITION_CATEGORY_NAMES = [
  "Non-hydrocarbon", "Hydrocarbon", "Plus Fraction Properties", "Composition Bulk Properties",
];
